/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{HTMLVisualElement as e}from"../html/HTMLVisualElement.js";import{SVGVisualElement as r}from"../svg/SVGVisualElement.js";import{isSVGComponent as o}from"./utils/is-svg-component.js";const t=(t,n)=>o(t)?new r(n,{enableHardwareAcceleration:!1}):new e(n,{enableHardwareAcceleration:!0});export{t as createDomVisualElement};
//# sourceMappingURL=create-visual-element.js.map
